import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '@shared/services/toast.service';
import { AurToastComponent } from '../aur-toast/aur-toast.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aur-toast-stack',
  standalone: true,
  imports: [AurToastComponent],
  template: `
    <div class="toast-stack" aria-live="polite">
      @for (toast of toastService.toasts(); track toast.id) {
        <aur-toast [config]="toast" (dismissed)="toastService.dismiss(toast.id)" />
      }
    </div>
  `,
})
export class AurToastStackComponent {
  readonly toastService = inject(ToastService);
}
